import React from 'react';

import iconEmpty from '../../../assets/icons/icon-empty.png';
import './NoData.css';


const NoData = (props) => {
  const { category, customClass } = props;

  return (
    <div className={`${customClass ? `${customClass} no-data` : 'no-data'}`}>
      <img alt="No Data" src={iconEmpty} />
      <p>You currently don't have any {category} to be displayed.</p>
    </div>
  );
};

export default NoData;
